import Penalty from "../../sports/football/fragments/penalty";
import PenaltyAccepted from "../../sports/football/fragments/penalty-accepted";
import PenaltyDeclined from "../../sports/football/fragments/penalty-declined";
import Offsetting from "../../sports/football/fragments/offsetting";
import NoPlay from "../../sports/football/fragments/no-play";
import StartOfPlay from "../../sports/football/fragments/start-of-play";
import Timeout from "../../sports/football/fragments/timeout";
import PatTry from "../../sports/football/fragments/pat-try";
import DropKick from "../../sports/football/fragments/drop-kick";
import Kick from "../../sports/football/fragments/kick";
import CflKick from "../../sports/football/fragments/cfl-kick";
import Run from "../../sports/football/fragments/run";
import Pass from "../../sports/football/fragments/pass";
import PatBlocked from "../../sports/football/fragments/pat-blocked";
import PatCompleted from "../../sports/football/fragments/pat-completed";
import PatIntercepted from "../../sports/football/fragments/pat-intercepted";
import PatFumbled from "../../sports/football/fragments/pat-fumbled";
import PatMissed from "../../sports/football/fragments/pat-missed";
import PatReturned from "../../sports/football/fragments/pat-returned";
import PatContinued from "../../sports/football/fragments/pat-continued";
import PatRecovered from "../../sports/football/fragments/pat-recovered";
import PatNotRecovered from "../../sports/football/fragments/pat-not-recovered";
import PatPointsAwarded from "../../sports/football/fragments/pat-points-awarded";
import PatPointsNotAwarded from "../../sports/football/fragments/pat-points-not-awarded";
import Rush from "../../sports/football/fragments/rush";
import Tackle from "../../sports/football/fragments/tackle";
import OutOfBounds from "../../sports/football/fragments/out-of-bounds";
import Fumble from "../../sports/football/fragments/fumble";
import Continued from "../../sports/football/fragments/continued";
import Returned from "../../sports/football/fragments/returned";
import Rouge from "../../sports/football/fragments/rouge";
import NoRecoveryKickReturn from "../../sports/football/fragments/no-recovery-kick-return";
import FieldGoal from "../../sports/football/fragments/field-goal";
import FieldGoalFumble from "../../sports/football/fragments/field-goal-fumble";
import FieldGoalFakeRun from "../../sports/football/fragments/field-goal-fake-run";
import FieldGoalFakePass from "../../sports/football/fragments/field-goal-fake-pass";
import FieldGoalGood from "../../sports/football/fragments/field-goal-good";
import FieldGoalMissed from "../../sports/football/fragments/field-goal-missed";
import FieldGoalBlocked from "../../sports/football/fragments/field-goal-blocked";
import KickOff from "../../sports/football/fragments/kick-off";
import Deuce from "../../sports/football/fragments/deuce";
import DeuceGood from "../../sports/football/fragments/deuce-good";
import DeuceMissed from "../../sports/football/fragments/deuce-missed";
// Rebound Net (Indoor Football - ball hits net and stays live)
import ReboundNet from "../../sports/football/fragments/rebound-net";
import ReboundNetCaughtOffense from "../../sports/football/fragments/rebound-net-caught-offense";
import ReboundNetCaughtDefense from "../../sports/football/fragments/rebound-net-caught-defense";
import ReboundNetHitGround from "../../sports/football/fragments/rebound-net-hit-ground";
import ReboundNetFieldedKicking from "../../sports/football/fragments/rebound-net-fielded-kicking";
import ReboundNetFieldedReceiving from "../../sports/football/fragments/rebound-net-fielded-receiving";
// Bar Ball (Indoor Football - kickoff hits goalpost)
import BarBall from "../../sports/football/fragments/bar-ball";
import BarBallRecoveredKicking from "../../sports/football/fragments/bar-ball-recovered-kicking";
import BarBallRecoveredReceiving from "../../sports/football/fragments/bar-ball-recovered-receiving";
import KickOffPenalty from "../../sports/football/fragments/kick-off-penalty";
import KickOffPenaltyAccepted from "../../sports/football/fragments/kick-off-penalty-accepted";
import KickOffPenaltyDeclined from "../../sports/football/fragments/kick-off-penalty-declined";
import Downed from "../../sports/football/fragments/downed";
import TouchBack from "../../sports/football/fragments/touch-back";
import FairCatch from "../../sports/football/fragments/fair-catch";
import KickNotRecovered from "../../sports/football/fragments/kick-not-recovered";
import KickRecovered from "../../sports/football/fragments/kick-recovered";
import OnSide from "../../sports/football/fragments/on-side";
import Punt from "../../sports/football/fragments/punt";
import PuntBlocked from "../../sports/football/fragments/punt-blocked";
import PuntOutOfBounds from "../../sports/football/fragments/punt-out-of-bounds";
import FieldGoalOutOfBounds from "../../sports/football/fragments/field-goal-out-of-bounds";
import PatPass from "../../sports/football/fragments/pat-pass";
import PassIntercepted from "../../sports/football/fragments/pass-intercepted";
import PassComplete from "../../sports/football/fragments/pass-complete";
import PassIncomplete from "../../sports/football/fragments/pass-incomplete";
import PassSacked from "../../sports/football/fragments/pass-sacked";
import PassDropped from "../../sports/football/fragments/pass-dropped";
import PassBrokenUp from "../../sports/football/fragments/pass-broken-up";
import PatKick from "../../sports/football/fragments/pat-kick";
import StartDrive from "../../sports/football/fragments/start-drive";
import GameControl from "../../sports/football/fragments/game-control";
import GameStart from "../../sports/football/fragments/game-start";
import StartPeriod from "../../sports/football/fragments/start-period";
import StatsCount from "../../sports/football/fragments/stats-count";
import EndOfPlay from "../../sports/football/fragments/end-of-play";
import UpdateContext from "../../sports/football/fragments/update-context";
import CoinToss from "../../sports/football/fragments/coin-toss";
import SwapTeams from "../../sports/football/fragments/swap-teams";
import FumbleRecovered from "../../sports/football/fragments/fumble-recovered";
import FumbleNotRecovered from "../../sports/football/fragments/fumble-not-recovered";
import Guard from "../../sports/common/utils/guard";
import FootballState from "../../sports/football/state/football-state";
import Safety from "../../sports/football/fragments/safety";
import FlagPatBlocked from "../../sports/flag-football/fragments/pat-blocked";
import FlagPatFumbled from "../../sports/flag-football/fragments/pat-fumbled";
import FlagPatKick from "../../sports/flag-football/fragments/pat-kick";
import FlagPatPass from "../../sports/flag-football/fragments/pat-pass";
import FlagPatTry from "../../sports/flag-football/fragments/pat-try";
import FlagRun from "../../sports/flag-football/fragments/run";
import Lateral from "../../sports/football/fragments/lateral";
import SportCodes from "../../sports/common/sport-codes";
import Muffed from "../../sports/football/fragments/muffed";
import SetTimeAndPeriod from "../../sports/football/fragments/set-time-and-period";
import CollectDriveTime from "../../sports/football/fragments/collect-drive-time";
import Spike from "../../sports/football/fragments/spike";
import KneelDown from "../../sports/football/fragments/kneeldown";
import SkipKickoff from "../../sports/football/fragments/skip-kickoff";
import FumbledSnap from "../../sports/football/fragments/fumbled-snap";
import FumbledSnapLost from "../../sports/football/fragments/fumbled-snap-lost";
import FumbledSnapRecovered from "../../sports/football/fragments/fumbled-snap-recovered";

const fragmentMappings = {
    [FootballState.SkipKickoff]: () => new SkipKickoff(),
    [FootballState.AddPlay]: () => new StartOfPlay(),
    [FootballState.Rush]: () => new Rush(),
    [FootballState.OutOfBounds]: () => new OutOfBounds(),
    [FootballState.Muffed]: () => new Muffed(),
    [FootballState.Fumble]: () => new Fumble(),
    [FootballState.FumbleRecovered]: () => new FumbleRecovered(),
    [FootballState.FumbleNotRecovered]: () => new FumbleNotRecovered(),
    [FootballState.Tackle]: () => new Tackle(),
    [FootballState.EndOfPlay]: ({ collectTime }) =>
        collectTime ? new CollectDriveTime() : new EndOfPlay(),
    [FootballState.NoPenaltyEndOfPlay]: ({ collectTime }) =>
        collectTime ? new CollectDriveTime() : new EndOfPlay(),
    // PENALTIES
    [FootballState.Penalty]: () => new Penalty(),
    [FootballState.SecondPenalty]: () => new Penalty(),
    [FootballState.PenaltyDeclined]: () => new PenaltyDeclined(),
    [FootballState.PenaltyAccepted]: () => new PenaltyAccepted(),
    [FootballState.Offsetting]: () => new Offsetting(),
    [FootballState.SecondOffsetting]: () => new Offsetting(),
    [FootballState.NoPlay]: () => new NoPlay(),
    [FootballState.StatsCount]: () => new StatsCount(),
    // PLAY PENALTIES
    [FootballState.PlayPenalty]: () => new Penalty(),
    [FootballState.PlayPenaltySecondPenalty]: () => new Penalty(),
    [FootballState.PlayPenaltyPenaltyDeclined]: () => new PenaltyDeclined(),
    [FootballState.PlayPenaltyPenaltyAccepted]: () => new PenaltyAccepted(),
    [FootballState.PlayPenaltyOffsetting]: () => new Offsetting(),
    [FootballState.PlayPenaltySecondOffsetting]: () => new Offsetting(),
    [FootballState.PlayPenaltyNoPlay]: () => new NoPlay(),
    [FootballState.PlayPenaltyStatsCount]: () => new StatsCount(),
    [FootballState.Timeout]: () => new Timeout(),
    [FootballState.UpdateContext]: () => new UpdateContext(),
    [FootballState.CoinToss]: () => new CoinToss(),
    //
    [FootballState.NoRecoveryKickReturn]: () => new NoRecoveryKickReturn(),
    [FootballState.FieldGoal]: () => new FieldGoal(),
    [FootballState.FieldGoalFumble]: () => new FieldGoalFumble(),
    [FootballState.FieldGoalFakeRun]: () => new FieldGoalFakeRun(),
    [FootballState.FieldGoalFakePass]: () => new FieldGoalFakePass(),
    [FootballState.FieldGoalGood]: () => new FieldGoalGood(),
    [FootballState.FieldGoalMissed]: () => new FieldGoalMissed(),
    [FootballState.FieldGoalBlocked]: () => new FieldGoalBlocked(),
    [FootballState.Kick]: () => new Kick(),
    [FootballState.CflKick]: () => new CflKick(),
    [FootballState.KickOff]: () => new KickOff(),
    // Deuce (Indoor Football - kickoff through uprights)
    [FootballState.Deuce]: () => new Deuce(),
    [FootballState.DeuceGood]: () => new DeuceGood(),
    [FootballState.DeuceMissed]: () => new DeuceMissed(),
    // Rebound Net (Indoor Football - ball hits net and stays live)
    [FootballState.HitReboundNet]: () => new ReboundNet(),
    [FootballState.ReboundNetCaughtOffense]: () =>
        new ReboundNetCaughtOffense(),
    [FootballState.ReboundNetCaughtDefense]: () =>
        new ReboundNetCaughtDefense(),
    [FootballState.ReboundNetHitGround]: () => new ReboundNetHitGround(),
    [FootballState.ReboundNetFieldedKicking]: () =>
        new ReboundNetFieldedKicking(),
    [FootballState.ReboundNetFieldedReceiving]: () =>
        new ReboundNetFieldedReceiving(),
    // Bar Ball (Indoor Football - kickoff hits goalpost)
    [FootballState.HitGoalpost]: () => new BarBall(),
    [FootballState.BarBallRecoveredKicking]: () =>
        new BarBallRecoveredKicking(),
    [FootballState.BarBallRecoveredReceiving]: () =>
        new BarBallRecoveredReceiving(),
    [FootballState.KickOffPenalty]: () => new KickOffPenalty(),
    [FootballState.KickOffPenaltyAccepted]: () => new KickOffPenaltyAccepted(),
    [FootballState.KickOffPenaltyDeclined]: () => new KickOffPenaltyDeclined(),
    [FootballState.Rouge]: () => new Rouge(),
    [FootballState.Downed]: () => new Downed(),
    [FootballState.TouchBack]: () => new TouchBack(),
    [FootballState.FairCatch]: () => new FairCatch(),
    [FootballState.KneelDown]: () => new KneelDown(),
    [FootballState.FumbledSnap]: () => new FumbledSnap(),
    [FootballState.FumbledSnapLost]: () => new FumbledSnapLost(),
    [FootballState.FumbledSnapRecovered]: () => new FumbledSnapRecovered(),
    [FootballState.KickRecovered]: () => new KickRecovered(),
    [FootballState.KickNotRecovered]: () => new KickNotRecovered(),
    [FootballState.OnSide]: () => new OnSide(),
    [FootballState.Punt]: () => new Punt(),
    [FootballState.PuntBlocked]: () => new PuntBlocked(),
    [FootballState.PuntOutOfBounds]: () => new PuntOutOfBounds(),
    [FootballState.FieldGoalOutOfBounds]: () => new FieldGoalOutOfBounds(),
    [FootballState.Continue]: () => new Continued(),
    [FootballState.Returned]: () => new Returned(),
    [FootballState.Pass]: () => new Pass(),
    [FootballState.PassIntercepted]: () => new PassIntercepted(),
    [FootballState.PassComplete]: () => new PassComplete(),
    [FootballState.PassIncomplete]: () => new PassIncomplete(),
    [FootballState.PassBrokenUp]: () => new PassBrokenUp(),
    [FootballState.PassDropped]: () => new PassDropped(),
    [FootballState.PassSacked]: () => new PassSacked(),
    [FootballState.DropKick]: () => new DropKick(),
    [FootballState.PatTry]: ({ sportCode }) =>
        sportCode === SportCodes.Football ? new PatTry() : new FlagPatTry(),
    [FootballState.PatKick]: ({ sportCode }) =>
        sportCode === SportCodes.Football ? new PatKick() : new FlagPatKick(),
    [FootballState.PatBlocked]: ({ sportCode }) =>
        sportCode === SportCodes.Football
            ? new PatBlocked()
            : new FlagPatBlocked(),
    [FootballState.PatCompleted]: () => new PatCompleted(),
    [FootballState.PatMissed]: () => new PatMissed(),
    [FootballState.PatFumbled]: ({ sportCode }) =>
        sportCode === SportCodes.Football
            ? new PatFumbled()
            : new FlagPatFumbled(),
    [FootballState.PatPass]: ({ sportCode }) =>
        sportCode === SportCodes.Football ? new PatPass() : new FlagPatPass(),
    [FootballState.PatIntercepted]: () => new PatIntercepted(),
    [FootballState.PatReturned]: () => new PatReturned(),
    [FootballState.PatContinued]: () => new PatContinued(),
    [FootballState.PatRecovered]: () => new PatRecovered(),
    [FootballState.PatNotRecovered]: () => new PatNotRecovered(),
    [FootballState.PatPointsAwarded]: () => new PatPointsAwarded(),
    [FootballState.PatPointsNotAwarded]: () => new PatPointsNotAwarded(),
    [FootballState.Run]: ({ sportCode }) =>
        sportCode === SportCodes.Football ? new Run() : new FlagRun(),
    [FootballState.Spike]: () => new Spike(),
    //GAME CONTROL
    [FootballState.GameControl]: () => new GameControl(),
    [FootballState.StartDrive]: () => new StartDrive(),
    [FootballState.GameStart]: () => new GameStart(),
    [FootballState.StartPeriod]: () => new StartPeriod(),
    [FootballState.SwapTeams]: () => new SwapTeams(),
    [FootballState.Safety]: () => new Safety(),
    [FootballState.Lateral]: () => new Lateral(),
    [FootballState.SetTimeAndPeriod]: () => new SetTimeAndPeriod()
};

class FragmentFactory {
    _buildFragment(
        fragment,
        playId,
        associatedState,
        fragmentData = {},
        playData = {}
    ) {
        Object.assign(fragment, {
            playId,
            associatedState,
            ruleSetId: playData.ruleSetId,
            ...fragmentData
        });
        fragment.onBuild?.(playData);
        return fragment;
    }

    build(playId, fragmentData, playData = {}) {
        const {
            associatedState,
            associatedTransition,
            associatedHistoryIndex
        } = fragmentData;

        Guard.required(associatedState, "associatedState");
        Guard.required(associatedTransition, "associatedTransition");
        Guard.required(associatedHistoryIndex, "associatedHistoryIndex");

        if (
            associatedState !== FootballState.Finalize &&
            !fragmentMappings[associatedState] &&
            associatedState !== "FINALIZE"
        ) {
            console.warn(
                "Fragment not initialized for state.",
                associatedState
            );
        }

        return (
            fragmentMappings[associatedState] &&
            this._buildFragment(
                fragmentMappings[associatedState](playData),
                playId,
                associatedState,
                fragmentData,
                playData
            )
        );
    }
}

export default new FragmentFactory();
